import {
  FETCH_SET_GLOBAL_TEMPLATE_NAME_REQUEST,
  FETCH_SET_GLOBAL_TEMPLATE_NAME_SUCCESS,
  FETCH_SET_GLOBAL_TEMPLATE_NAME_FALUIRE,
} from './setGlobalTemplateNameTypes'

const initialState = {
  loading: false,
  globalTemplateName: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_SET_GLOBAL_TEMPLATE_NAME_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_SET_GLOBAL_TEMPLATE_NAME_SUCCESS : return {
      ...state,
      globalTemplateName: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_SET_GLOBAL_TEMPLATE_NAME_FALUIRE : return {
      ...state,
      loading: false,
      globalTemplateName: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
